import { State } from "./State";
import { Action } from "./Actions";
import { client } from "lib/api";

const Reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: action.user,
        apiClient: action.client,
        org: action.org,
        messages: action.messages,
        isAuthenticated: true,
      };
    case "LOGOUT":
      if (state.messages) {
        state.messages.disconnect();
      }
      return {
        ...state,
        apiClient: client,
        isAuthenticated: false,
        org: null,
        user: null,
        messages: null,
      };
    case "UPDATE_ORG":
      return {
        ...state,
        org: action.org,
      };
  }
};

export default Reducer;
